export default __webpack_public_path__ + "809f40660eb431aa81bacfa6ee7a4dfe.ico";